import { render, staticRenderFns } from "./SectionalFilter.vue?vue&type=template&id=10a19042&scoped=true"
import script from "./SectionalFilter.vue?vue&type=script&lang=js"
export * from "./SectionalFilter.vue?vue&type=script&lang=js"
import style0 from "./SectionalFilter.vue?vue&type=style&index=0&id=10a19042&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a19042",
  null
  
)

export default component.exports